module.exports = __webpack_public_path__ + "media/site/images/vrbb-logo-4c0ec4c4cc7245adf65864fab3dacbe8.jpeg";